import classnames from 'classnames';
import React from 'react';
import { Badge } from 'reactstrap';

import * as Session from '../../utils/session';
import openSignInDialog from '../dialog/open';

function doOpenSignInDialog(event) {
  event.preventDefault();
  openSignInDialog();
}

class SessionTimer extends React.Component {
  constructor(props) {
    super(props);

    this.state = { session: Session.read() };

    this.tick = this.tick.bind(this);
  }

  componentDidMount() {
    this.tickInterval = setInterval(this.tick, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.tickInterval);
  }

  tick() {
    this.setState({
      session: Session.read(),
    });
  }

  render() {
    const { session } = this.state;
    const remainingSeconds = session ? session.ttl : 0;
    const remainingMinutes = Math.round(remainingSeconds / 60);

    const theEndIsNear = remainingMinutes <= 5;

    const badgeColor = theEndIsNear ? 'danger' : 'light';
    const badgeClass = classnames({ 'flash--white': theEndIsNear });

    return (
      <div className="nav-link">
        <Badge
          color={badgeColor}
          className={badgeClass}
          tag="a"
          title={`Your current session is valid for another ${remainingMinutes} minutes.`}
          onClick={doOpenSignInDialog}
          href="/login/dialog"
        >
          {remainingMinutes > 0
            ? `${remainingMinutes}'`
            : `${remainingSeconds}"`}
        </Badge>
      </div>
    );
  }
}

export default SessionTimer;
